import cartService, { getOrderId, setOrderId } from "../../services/cartService";
import locationService from "../../services/locationService";
import { CartState } from "../../utils/interfaces/cart";
import { CountryRegionState } from "../../utils/interfaces/locations";
import paymentService from "../../services/paymentService";
import { baseRouterPath } from "../../utils/constants";

export const getStatesList = async (
  setCountryStates: (res: CountryRegionState) => void
) => {
  await locationService.setCountryStates(setCountryStates, () => {});
};

export const checkPaymentStatus = async (router: any) => {
  let orderId = getOrderId();
  if (orderId && orderId?.length > 0) {
    await paymentService
      .cancelOrder(orderId)
      .then(async (res: any) => {
        if (res.cart.id) {
          setOrderId("");
          router.navigate(`${baseRouterPath}/response/failed`);
        }
      })
      .catch((e: Error) => {
        // add error handling
      });
  }
};

export const setBillingAddressOnCart = (cartData: any, setCart: Function) => {
  let lnFe = cartData.ln_fe.map(({__typename, ...lnfe}: any) => {
    return lnfe;
  });
  const params: any = {
    cartId: cartData.id,
    firstname: cartData.billing_address.firstname,
    lastname: cartData.billing_address.lastname,
    telephone: cartData.billing_address.telephone,
    jobTitle: cartData.custom_attributes.ln_job_title,
    company: cartData.billing_address.company,
    street: cartData.billing_address.street,
    city: cartData.billing_address.city,
    region: cartData.billing_address.region.region_id.toString(),
    postcode: cartData.billing_address.postcode,
    lnFe: lnFe?? [],
    country_code: cartData.billing_address.country.code
  };
  cartService.setBillingAddressOnCart(params).then((res) => {
    setCart(res);
  })
  .catch((err: Error) => {
    // add error handling
  });
}

export const addBundleItemsToCart = async (sku: string, cart: CartState) => {
  // To be used in future to add product to cart from url
};
